import * as types from '../actionTypes/CartActionTypes';

export default function UpdateCartItemInitReducer(state = '', action) {
    // NOSONAR
    switch (
        action.type // NOSONAR
    ) {
        case types.UPDATE_CART_IN_PROGRESS:
            return action.updateCartItemId || state;
        default:
            return state;
    }
}
